import Button from '@mui/material/Button'

interface Props {
  onClick: (event: any, color: string) => void
  color: string
  count: number
}

export const KpiButton = ({ onClick, color, count }: Props) => {
  const backgroundColor = color === 'amber' ? 'darkorange' : color

  return (
    <Button
      onClick={(event) => onClick(event, color)}
      size="small"
      sx={{
        color: 'white',
        borderRadius: '100%',
        backgroundColor,
        '&:hover': {
          backgroundColor,
          opacity: 0.5,
        },
      }}
    >
      {count}
    </Button>
  )
}
